<template>
	<div class="language-selector">
		<b-button
			class="language-selector__button button no-bg"
			@click="canShowBottomSheet = true"
		>
			<span class="language-selector__button__text">EN</span>
			<svg
				class="language-selector__button__icon"
				viewBox="0 0 9 5"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					d="M0.847656 0C0.601562 0 0.4375 0.136719 0.355469 0.355469C0.246094 0.574219 0.300781 0.765625 0.464844 0.929688L3.99219 4.45703C4.10156 4.56641 4.21094 4.62109 4.375 4.62109C4.51172 4.62109 4.64844 4.56641 4.75781 4.45703L8.28516 0.929688C8.44922 0.765625 8.47656 0.574219 8.39453 0.355469C8.28516 0.136719 8.12109 0 7.90234 0H0.847656Z"
				/>
			</svg>
		</b-button>
		<bottom-sheet
			:ref="'languageSelectorBottomSheet'"
			v-if="canShowBottomSheet"
			@close="closeBottomSheet"
			@has-mounted="showBottomSheet"
		>
			<div style="padding: 20px">Languages</div>
		</bottom-sheet>
	</div>
</template>

<script>
export default {
	data() {
		return {
			canShowBottomSheet: false,
		};
	},
	methods: {
		showBottomSheet() {
			this.canShowBottomSheet = true;
			this.$nextTick(() => {
				this.$refs.languageSelectorBottomSheet.setState("open");
			});
		},
		closeBottomSheet() {
			this.$refs.languageSelectorBottomSheet.setState("close");
			this.$nextTick(() => {
				this.canShowBottomSheet = false;
			});
		},
	},
};
</script>

<style lang="scss">
.language-selector {
	&__button {
		display: flex;
		flex-direction: row;
		align-items: center;
		&__text {
			color: var(--black);
			font-size: var(--font-medium);
			margin-right: 5px;
		}
		&__icon {
			width: 10px;
			path {
				fill: var(--black);
			}
		}
	}
}
</style>
